var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-shell"},[_c('app-bar'),_c('drawer'),_c('v-main',{staticClass:"app-main"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }